import React, { createContext, useEffect, useState } from "react";

import { PropsType } from "../../interfaces/ChildrenType";

import { ProductContextType } from "./product-context.types";
import { GoodTypes } from "../../interfaces/MerchantInfo";

const productData = sessionStorage.getItem("CEX-ProductData");

const initialState: ProductContextType = {
  product: JSON.parse(productData as string)?.product || null,

  setProduct: () => {},

  amount: JSON.parse(productData as string)?.amount || null,

  setAmount: () => {},
};

export const ProductContext = createContext(initialState);

export const ProductContextProvider: React.FC<PropsType> = ({ children }) => {
  const [product, setProduct] = useState<GoodTypes | null | undefined>(initialState.product);

  const [amount, setAmount] = useState<number | null>(initialState.amount);

  useEffect(() => {
    if (product || amount) {
      const data ={ product, amount };
      sessionStorage.setItem('CEX-ProductData', JSON.stringify(data))
    }
  }, [product, amount])

  return (
    <ProductContext.Provider value={{ product, setProduct, amount, setAmount }}>
      {children}
    </ProductContext.Provider>
  );
};
